import React from 'react';
import styled from 'styled-components';
import { googleMapApiKey } from '../../../constants';


const MapWrapper = styled.div`
  height: 100%;
  width: 100%;
  min-height: 300px;
  max-height: 350px;
  box-shadow: 4px 4px 0 0 rgba(0,0,0,0.1);
 
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.extraLarge}) {
    max-width: 500px;
  }
`;

const googleMapSrc: string = `https://www.google.com/maps/embed/v1/place?key=${googleMapApiKey}
&q=Common+Wombat,+aleja+Grunwaldzka+203%2F2%2Fpokój+6,+80-266+Gdańsk`;


const Map = () => (
  <MapWrapper>
    <iframe
      title="CommonWombat"
      width="100%"
      height="100%"
      frameBorder="0"
      src={googleMapSrc}
    />
  </MapWrapper>
);

export default Map;
